<template>
    <li class="books-card" @click="getBookId">
        <img :src="getImgCover(item.cover)" alt="" v-lazy="getImgCover(item.cover)" data-loading="../assets/imgloading.jfif" />
        <div class="book-detail">
            <h5>{{ item.title }}</h5>
            <span class="book-author">{{ item.author }}</span> <span class="book-cat">{{ item.cat }}</span>
            <p>{{ item.shortIntro }}</p>
            <span class="book-wordCount"> {{ getWordCount(item.wordCount) }} | </span>
            <span ><span class="keep">{{ item.retentionRatio}}%</span>留存率</span>
        </div>
    </li>
</template>

<script>
export default {
    props: ["item"],
    data() {
        return {};
    },
    methods: {
        getBookId() {
            window.console.log(this.item._id,'xxx');

            this.$router.push({
                path: "singlebookdetail",
                query: {
                    id: this.item._id
                }
            });
            this.$store.commit("setBookDetailId", {
                value: this.item._id
            });
        },
        getImgCover(url) {
            // return url.replace("/agent/","");
            return "https://statics.zhuishushenqi.com" + url;
        },
        getWordCount(num) {
            if (num > 10000) {
                let n = num / 10000;
                return n.toFixed(0) + "万字";
            } else {
                return num + "字";
            }
        }
    }
};
</script>

<style lang="less" scope>
li.books-card {
    padding: 15px 0 15px 15px;
    border-bottom: 1px solid rgb(231, 231, 231);
    img {
        float: left;
        width: 70px;
        height: 100px;
        margin-right: 15px;
        border-radius: 2px;
        box-shadow: 0 2px 1px 2px rgba(0, 0, 0, 0.15);
    }
    .book-detail {
        h5 {
            font-size: 14px;
            margin: 5px 0;
        }
        p {
            color: #999;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 10px;
            margin: 5px 0;
        }
        span {
            color: #999;
            font-size: 10px;
            &.book-author {
                &::after {
                    content: "|";
                    display: inline-block;
                    margin: 0 10px;
                }
            }
            &.book-cat {
            }
            &.book-wordCount {

            }
            span.keep{
                color: red;
            }
        }
    }
}
</style>
